import cls from './top-bar-section.module.scss'
import createSimpleComponent from '../createSimpleComponent'

export default createSimpleComponent({
  displayName: 'TopBarSection',
  className: cls.wrapper,
  Component: 'div',
})
